import { Record } from "immutable";

// Precisely identify a location along a trackpoint array by providing
// a left index, and a float offset. This allows us to point to locations
// along a track that are between indices.
export const TrackLocation = Record({ left: 0, percent: 0 });

TrackLocation.closestIndex = (tl) => Math.round(tl.left + tl.percent);
TrackLocation.right = (tl) => tl.left + 1;
